module.exports = __webpack_public_path__ + "img/2012-08-18 09.13.03.c5e5ff03.jpg";